<template>
  <section class="bloc-main-text scroll-step js-scroll-show">
    <div class="bloc-main-text__wrapper">      
      <h2 v-if="content.title" class="bloc-main-text__title">{{ content.title }}</h2>
      
      <div class="bloc-main-text__text-emphase" v-html="content.text_emphase" />
      
      <div class="bloc-main-text__text" :class="{'small' : content.small_text, 'has-quote' : content.quotted_text}">
        <span v-if="content.quotted_text" class="quote quote-top" >“</span>
        <p  v-html="content.text"/>
        <span v-if="content.quotted_text" class="quote quote-bottom">“</span>
      </div>

      <span v-if="content.info" class="bloc-main-text__info">
        <a v-if="content.anchor" :href="content.anchor" ref="anchor">
          {{ content.info }}
        </a>
        <span v-else>{{ content.info }}</span>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MainText',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-main-text {
    width: 100vw;
    margin: rem(60) 0;
    overflow: hidden;
    position: relative;
    z-index: 1;

    @include media($from: small) {
      margin: rem(120) 0;

      .page-chefs & {
        margin: rem(100) 0;
      }
    }

    .desktop & {
      overflow: initial;
    }

    &__wrapper {
      width: grid_m(4.5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: grid(12, 11);
      }
    }

    &__title {
      @include paragraph($type: 'extrabig-krug-hand', $color: $th-cherry, $uppercase: false);
      position: relative;
      font-style: italic;
      text-align: center;
      display: block;
      margin: 0 auto;
      margin-bottom: 30px;

      @include media($from: small) {
        max-width: grid(10, 9);
      }
    }

     &__text-emphase {
      @include paragraph($type: 'big-gotham', $color: $th-cherry, $uppercase: true);
      position: relative;
      text-align: center;
      display: block;
      margin: 0 auto;
      margin-bottom: 40px;

      @include media($from: small) {
        max-width: grid(10, 9);
        margin-bottom: 60px;
      }

      h1 {
        @include paragraph($type: 'big-gotham', $color: $th-cherry, $uppercase: true);
      }

      strong {
        @include paragraph($type: 'big-gotham-medium', $color: $th-cherry, $uppercase: true);
      }
    }

    &__text {
      @include paragraph($type: 'big', $color: $th-grey, $uppercase: false);
      position: relative;
      color: $th-grey;
      text-align: center;
      display: block;
      margin: 0 auto;
      margin-top: 30px;

      @include media($from: small) {
        max-width: grid(7, 6);

        &.small {
          max-width: grid(6, 4);
        }
      }

      &.has-quote {
        @include paragraph($type: 'big-italic', $color: $th-grey, $uppercase: false);
        margin-bottom: rem(60);
      }

      i {
        @include paragraph($type: 'big-italic', $color: $th-grey, $uppercase: false);
      }

      .quote {
        @include paragraph($type: 'extrabig-krug-hand', $color: $th-grey, $uppercase: false);
        font-size: rem(32);
        position: absolute;

        &-top {
          margin-top: rem(-14);
          margin-left: rem(-25);

          @include media($from: small) {
            margin-top: rem(-24);
            margin-left: rem(-30);
          }
        }
        
        &-bottom {
          margin-top: rem(10);
          margin-left: rem(-27);

          @include media($from: small) {
            margin-top: rem(14);
            margin-left: rem(-30);
          }
        }
      }
    }

    &__info {
      @include paragraph($type: 'small-gotham', $color: $th-cherry, $uppercase: true);
      margin: 0 auto;
      margin-top: 30px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 1;
      position: relative;

      a {
        color: $th-yellow;
      }
    }
  }
</style>
